import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=d63eef7a&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d63eef7a')) {
      api.createRecord('d63eef7a', component.options)
    } else {
      api.reload('d63eef7a', component.options)
    }
    module.hot.accept("./FeedbackDialog.vue?vue&type=template&id=d63eef7a&", function () {
      api.rerender('d63eef7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/FeedbackDialog.vue"
export default component.exports